import parsePhoneNumber, {
  isValidPhoneNumber,
  validatePhoneNumberLength,
} from 'libphonenumber-js'

import {
  PhoneNumberValidation,
  PhoneNumberValidationErros,
  ValidatorErrorMessages,
} from './validators.type'

export const validatePassword = (password: string) => {
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password)
  const hasDigit = /\d/.test(password)
  const hasUppercase = /[A-Z]/.test(password)
  const hasLowercase = /[a-z]/.test(password)

  if (!hasSpecialChar || !hasDigit || !hasUppercase || !hasLowercase) {
    return ValidatorErrorMessages.WEAK_PASSWORD
  }

  return null
}

export const validateLengthBetween = (
  min: number,
  max: number,
  field: string,
  value?: string,
) => {
  if (value && value.length > 0) {
    if (value.length < min || value.length > max) {
      return `${field} must be between ${min}-${max} characters long!`
    }
  }
  return null
}

export const isDigitOnly = (field: string, value?: string) => {
  if (value && /^[0-9]*$/.test(value)) {
    return null
  }
  return `${field} must contain only digits!`
}

export const validatePhoneNumberField = (phoneNumber: string) => {
  const parsedPhoneNumber = parsePhoneNumber(phoneNumber)
  if (!parsedPhoneNumber) return
  const countryCode = parsedPhoneNumber.country
  const phoneNumberLength = validatePhoneNumberLength(phoneNumber, countryCode)
  if (phoneNumberLength === PhoneNumberValidation.SHORT) {
    return PhoneNumberValidationErros.SHORT
  }
  if (!isValidPhoneNumber(parsedPhoneNumber?.number, countryCode)) {
    return PhoneNumberValidationErros.INVALID
  }
  return null
}
